import { useQuery } from "@tanstack/react-query";
import boardPermissionRequestService from "../api/boardPermissionRequestService";

export const useQualifyingBoards = () => {
  const { getQualifyingBoards } = boardPermissionRequestService();

  return useQuery({
    queryKey: ["get-qualifying-boards"],
    queryFn: async () => {
      const res = await getQualifyingBoards();
      return res.data;
    },
  });
};

export const useHasPendingBoardPermissionRequests = (isAdmin) => {
  const { hasPendingPermissions } = boardPermissionRequestService();

  return useQuery({
    queryKey: ["has-pending-board-permission-requests"],
    queryFn: async () => {
      const res = await hasPendingPermissions();
      return res.data;
    },
    enabled: !!isAdmin,
  });
};

export const useUserHasPendingBoardPermissionRequests = () => {
  const { userHasPendingPermissions } = boardPermissionRequestService();

  return useQuery({
    queryKey: ["user-has-pending-board-permission-requests"],
    queryFn: async () => {
      const res = await userHasPendingPermissions();
      return res.data;
    },
  });
};
